import React, { FunctionComponent } from 'react';

import { TextSmall } from 'components/chroma/extended';

import { privacyPolicy } from 'scenes/common/helpers/contacts';

const Disclaimer: FunctionComponent = () => (
  <TextSmall margin={{ top: 5 }}>
    We collect, use and disclose your personal information in accordance with
    the IAL and Coles{' '}
    <a href={privacyPolicy()} target="_blank" rel="noopener noreferrer">
      Privacy Policies.
    </a>
  </TextSmall>
);

export default Disclaimer;
